module.exports = __webpack_public_path__ + "img/compass.3f44a78a.svg";